<template>
  <b-card>
    <b-modal
      id="reset-acceptance-modal"
      title="Reset Acceptance Confirmation"
    >
      <h6 class="text-center">
        Are you sure you want to reset this driver acceptance rate?
      </h6>
      <template #modal-footer="{close}">
        <b-row style="width:100%">
          <b-col md="6">
            <b-button
              block
              variant="danger"
              @click="close"
            >
              Cancel
            </b-button>
          </b-col>
          <b-col md="6">
            <b-button
              block
              variant="primary"
              :disabled="submitting"
              @click="resetHandler"
            >
              <BSpinner
                v-if="submitting"
                small
              />
              <span v-else>Confirm</span>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
    <b-button
      variant="danger"
      @click="$bvModal.show('reset-acceptance-modal')"
    >
      Reset Acceptance Rate
    </b-button>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import {
  BButton, BCard, BModal, BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BModal,
    BSpinner,
  },
  setup(_, ctx) {
    const driverExternalId = ctx.root.$route.query.externalId
    const submitting = ref(false)
    const resetHandler = async () => {
      try {
        submitting.value = true
        await ctx.root.$store.dispatch('driverView/resetDriverAcceptanceRate', driverExternalId)
        successNotification('Acceptance rate successfully resetted')
        ctx.root.$bvModal.hide('reset-acceptance-modal')
      } catch (error) {
        errorNotification('An error occured')
      } finally {
        submitting.value = false
      }
    }

    return {
      submitting,
      resetHandler,
    }
  },
}
</script>
